import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsClustersRedesign } from 'shared/map-search/selectors/clustersType';
import { TFeature } from 'shared/map-search/types/map';

import { useNewbuildingPromoPinsContext } from '../context';

export const HoverHandlers: React.FC = () => {
  const { newbuildingsPromoPinsManager } = useNewbuildingPromoPinsContext();
  const isClustersRedesign = useSelector(selectIsClustersRedesign);
  const lastHoveredPin = React.useRef<TFeature | null>(null);

  const handleObjectMouseLeave = React.useCallback(() => {
    if (!lastHoveredPin.current) {
      return;
    }

    const nextProperties = {
      ...lastHoveredPin.current.properties,
      isHovered: false,
    };

    newbuildingsPromoPinsManager.updatePinProperties(`nbpin_${lastHoveredPin.current.id}`, nextProperties);
    newbuildingsPromoPinsManager.updateBalloonProperties(lastHoveredPin.current.id, nextProperties);

    lastHoveredPin.current = null;
  }, [newbuildingsPromoPinsManager]);

  const handleObjectMouseEnter = React.useCallback(
    (event: YMaps.IEvent) => {
      const objectId = event.get<string>('objectId');
      const feature = newbuildingsPromoPinsManager.objectManager.objects.getById<TFeature>(objectId);

      const nextProperties = {
        ...feature.properties,
        isHovered: true,
      };

      /**
       * @description
       * В feature может приходить как pin, так и balloon (потому что они лежат в одном objectManager).
       * Их отличие в id: у pin id начинается с nbpin_.
       */
      const id = feature.id.split('nbpin_').pop() as string;

      newbuildingsPromoPinsManager.updatePinProperties(`nbpin_${id}`, nextProperties);
      newbuildingsPromoPinsManager.updateBalloonProperties(id, nextProperties);

      lastHoveredPin.current = { ...feature, id };
    },
    [newbuildingsPromoPinsManager],
  );

  React.useEffect(() => {
    if (!isClustersRedesign) {
      return () => {};
    }

    newbuildingsPromoPinsManager.objectManager.objects.events.add('mouseenter', handleObjectMouseEnter);
    newbuildingsPromoPinsManager.objectManager.objects.events.add('mouseleave', handleObjectMouseLeave);

    return () => {
      newbuildingsPromoPinsManager.objectManager.objects.events.remove('mouseenter', handleObjectMouseEnter);
      newbuildingsPromoPinsManager.objectManager.objects.events.remove('mouseleave', handleObjectMouseLeave);
    };
  }, [newbuildingsPromoPinsManager, isClustersRedesign, handleObjectMouseEnter, handleObjectMouseLeave]);

  return null;
};
